import {
  FaTachometerAlt, FaUsers, FaCalendarCheck,
  FaAngleLeft, FaAngleRight, FaCalendarMinus, FaFileAlt, FaBell,
} from "react-icons/fa";
// import { RiTeamLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/authcontext";

export default function Sidebar({ collapsed, setCollapsed, mobileOpen, onMobileClose }) {
  const { hasPermission, hasAnyPermission } = useAuth();

  // On phones the sidebar is an off-canvas drawer — tapping a menu item
  // should navigate AND close the drawer, same as Gmail/Notion/Linear.
  // On desktop/tablet this is a no-op since onMobileClose is undefined.
  const handleItemClick = () => {
    onMobileClose?.();
  };

  return (
    <>
      {/* Backdrop — only rendered/visible on phone widths (see layout.css
          .sidebar-overlay), tapping it closes the drawer. */}
      <div
        className={`sidebar-overlay ${mobileOpen ? "visible" : ""}`}
        onClick={onMobileClose}
        aria-hidden="true"
      />

      <div
        className={
          [
            "sidebar",
            collapsed ? "collapsed" : "",
            mobileOpen ? "mobile-open" : "",
          ]
            .filter(Boolean)
            .join(" ")
        }
      >
        <div className="sidebar-header">
          <h2>Syrano</h2>
          <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? <FaAngleRight /> : <FaAngleLeft />}
          </button>
        </div>

        <nav className="sidebar-menu">
          <NavLink to="/dashboard" className="menu-item" data-label="Dashboard" onClick={handleItemClick}>
            <FaTachometerAlt />
            <span>Dashboard</span>
          </NavLink>

          {hasPermission("employee.view") && (
            <NavLink to="/employee" className="menu-item" data-label="Employees" onClick={handleItemClick}>
              <FaUsers />
              <span>Employees</span>
            </NavLink>
          )}

          {hasAnyPermission(["attendance.view", "regularization.view", "regularization.create"]) && (
            <NavLink to="/attendance" className="menu-item" data-label="Attendance" onClick={handleItemClick}>
              <FaCalendarCheck />
              <span>Attendance</span>
            </NavLink>
          )}

          {hasAnyPermission(["dsr.view", "dsr.view_others"]) && (
            <NavLink to="/dsr" className="menu-item" data-label="DSR" onClick={handleItemClick}>
              <FaFileAlt />
              <span>DSR</span>
            </NavLink>
          )}

          {hasPermission("leave.view") && (
            <NavLink to="/leaves" className="menu-item" data-label="Leaves" onClick={handleItemClick}>
              <FaCalendarMinus />
              <span>Leaves</span>
            </NavLink>
          )}

          {hasPermission("notification.view") && (
            <NavLink to="/notifications" className="menu-item" data-label="Notifications" onClick={handleItemClick}>
              <FaBell />
              <span>Notifications</span>
            </NavLink>
          )}

          {/* 

          {hasPermission("task.view") && (
            <NavLink to="/task" className="menu-item" data-label="Tasks" onClick={handleItemClick}>
              <FaTasks />
              <span>Tasks</span>
            </NavLink>
          )}

          {hasPermission("project.view") && (
            <NavLink to="/project" className="menu-item" data-label="Projects" onClick={handleItemClick}>
              <FaProjectDiagram />
              <span>Projects</span>
            </NavLink>
          )}

          {hasPermission("team.view") && (
            <NavLink to="/team" className="menu-item" data-label="Teams" onClick={handleItemClick}>
              <RiTeamLine />
              <span>Teams</span>
            </NavLink>
          )}

          {hasPermission("client.view") && (
            <NavLink to="/clients" className="menu-item" data-label="Clients" onClick={handleItemClick}>
              <FaHandshake />
              <span>Clients</span>
            </NavLink>
          )} */}

        </nav>
      </div>
    </>
  );
}
